import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import DataPegawai from '../views/Profil/DataPegawai.vue'
import StrukturOrganisasi from '../views/Profil/StrukturOrganisasi.vue'
import TugasPokok from '../views/Profil/TugasPokok.vue'
import VisiMisi from '../views/Profil/VisiMisi.vue'
import bidangPerkebunan from '../views/unitKerja/bidangPerkebunan.vue'
import bidangSarpras from '../views/unitKerja/bidangSarpras.vue'
import bidangTanamanPangan from '../views/unitKerja/bidangTanamanPangan.vue'
import bidangHortikultura from '../views/unitKerja/bidangHortikultura.vue'
import sekretariat from '../views/unitKerja/sekretariat.vue'
import produksiBenih from '../views/uptd/produksiBenih.vue'
import formulir from '../views/dokumen/formulir.vue'
import sop from '../views/dokumen/sop.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/DataPegawai',
    name: 'DataPegawai',
    component: DataPegawai
  },
  {
    path: '/StrukturOrganisasi',
    name: 'StrukturOrganisasi',
    component: StrukturOrganisasi
  },
  {
    path: '/TugasPokok',
    name: 'TugasPokok',
    component: TugasPokok
  },
  {
    path: '/VisiMisi',
    name: 'VisiMisi',
    component: VisiMisi
  },
  {
    path: '/bidangPerkebunan',
    name: 'bidangPerkebunan',
    component: bidangPerkebunan
  },
  {
    path: '/bidangSarpras',
    name: 'bidangSarpras',
    component: bidangSarpras
  },
  {
    path: '/bidangTanamanPangan',
    name: 'bidangTanamanPangan',
    component: bidangTanamanPangan
  },
  {
    path: '/bidangHortikultura',
    name: 'bidangHortikultura',
    component: bidangHortikultura
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: sekretariat
  },
  {
    path: '/produksiBenih',
    name: 'produksiBenih',
    component: produksiBenih
  },
  {
    path: '/formulir',
    name: 'formulir',
    component: formulir
  },
  {
    path: '/sop',
    name: 'sop',
    component: sop
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
